import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';

@JsonObject('model.Item')
export class Item extends AbstractModel {

  @JsonProperty(Number, 'id')
  id?: number;

  @JsonProperty(String, 'name')
  name: string;

  @JsonProperty(Number, 'version')
  version: number;

  @JsonProperty(Number, 'groupId')
  groupId?: number;

  @JsonProperty(Number, 'projectId')
  projectId?: number;

  @JsonProperty(Number, 'pricePerItem')
  pricePerItem: number;

  @JsonProperty(Number, 'pricePerItemInstall')
  pricePerItemInstall: number;

  @JsonProperty(String, 'description')
  description?: string

  @JsonProperty(Boolean, 'hasFiles')
  hasFiles?: boolean

  forThisProjectOnly?: boolean
}
